import biLogger from '@wix/web-bi-logger';
import * as BiConsts from '../../consts/bi';

export class BiLogger {
  private readonly logger = biLogger
    .factory({ endpoint: 'dash' })
    .updateDefaults({ src: 5 })
    .logger();

  constructor(private msid: string) {
  }

  public reportMuteAllSite = (toggle: boolean) => this.logger.log({
    evid: BiConsts.MUTE_ALL_SITE,
    msid: this.msid,
    toggle
  })

  public reportTurnOnPushForFirstTime = () => this.logger.log({
    evid: BiConsts.TURN_ON_PUSH_FIRST_TIME,
    feed_name: 'Setting',
    origin: this.msid
  })

  public reportTogglePush = (toggle: boolean) => this.logger.log({
    evid: BiConsts.TOGGLE_PUSH,
    msid: this.msid,
    channel: 'desktop',
    section: 'desktop',
    group: 'desktop',
    toggle
  })

  public reportBrowserPermissionToggleDisplayed = (permission: NotificationPermission) => this.logger.log({
    evid: BiConsts.BROWSER_PERMISSION_TOGGLE_DISPLAYED,
    feed_name: 'Setting',
    origin: this.msid,
    permission_type: permission
  })

  public reportToggleNotificationGroup = (toggle: boolean, channel: string, section: string, group: string) => this.logger.log({
    evid: BiConsts.TOGGLE_NOTIFICATION_GROUP,
    msid: this.msid,
    toggle,
    channel,
    section,
    group
  })

  public reportIsOneappInstalled = (isInstalled: boolean) => this.logger.log({
    evid: BiConsts.IS_ONEAPP_INSTALLED,
    msid: this.msid,
    is_installed_oneapp: isInstalled
  })

  public reportInstallOneappLinkClicked = () => this.logger.log({
    evid: BiConsts.INSTALL_ONEAPP_CLICKED,
    msid: this.msid,
    name: 'install oneapp',
    origin: 'notification settings',
    value: 'https://apps.wix.com/mobile/v1/mobile-redirect/wix-one-app?referralAdditionalInfo=NOTIFICATIONS_SETTINGS'
  })

  public reportDesktopPushDenied = () => this.logger.log({
    evid: BiConsts.DESKTOP_PUSH_PERMISSIONS_DENIED,
    msid: this.msid
  })

  public reportCollapseExpandChannel = (channel: string, expand: boolean) => this.logger.log({
    evid: BiConsts.CLICK_ON_CHANNEL_SETTINGS,
    msid: this.msid,
    channel,
    click_name: expand ? 'expand' : 'collapse',
  })

  public reportClickOnChannelLink = (channel: string, url: string, hasSettings: boolean) => this.logger.log({
    evid: BiConsts.CLICK_ON_CHANNEL_LINK,
    msid: this.msid,
    channel,
    url,
    has_settings: hasSettings,
  })}
